const bannersForAdmin = `
  query {
    result: bannersForAdmin {
      id
      name
      link
      image440Url
      image1024Url
      image1368Url
      active
      order
      city {
        id
        name
        slug
      }
    }
  }
`

const banners = `
  query ($cityId: ID!) {
    result: banners(cityId: $cityId) {
      id
      createdAt
      updatedAt
      name
      link
      image440Url
      image1024Url
      image1368Url
      active
      order
      city {
        id
        name
        slug
      }
    }
  }
`

const bannerCreate = `
  mutation ($params: BannerInput!, $image440: ImageInput!, $image1024: ImageInput!, $image1368: ImageInput!) {
    result: bannerCreate(params: $params, image440: $image440, image1024: $image1024, image1368: $image1368) {
      banner {
        id
        createdAt
        updatedAt
        name
        link
        image440Url
        image1024Url
        image1368Url
        active
        order
        city {
          id
          name
          slug
        }
      }
      errors {
        path
        text
      }
    }
  }
`

const bannerUpdate = `
  mutation ($id: ID!, $params: BannerInput!) {
    result: bannerUpdate(id: $id, params: $params) {
      banner {
        id
        createdAt
        updatedAt
        name
        link
        image440Url
        image1024Url
        image1368Url
        active
        order
        city {
          id
          name
          slug
        }
      }
      errors {
        path
        text
      }
    }
  }
`

const bannerUpdateImage = `
  mutation ($id: ID!, $image: ImageInput!, $imageResolution: BannerImageResolutionEnum!) {
    result: bannerUpdateImage(id: $id, image: $image, imageResolution: $imageResolution) {
      banner {
        id
        createdAt
        updatedAt
        name
        link
        image440Url
        image1024Url
        image1368Url
        active
        order
        city {
          id
          name
          slug
        }
      }
      errors {
        path
        text
      }
    }
  }
`

const banner = `
  query ($id: ID!) {
    result: banner(id: $id) {
      id
      createdAt
      updatedAt
      name
      link
      image440Url
      image1024Url
      image1368Url
      active
      order
      city {
        id
        name
        slug
      }
    }
  }
`

export default {
  bannersForAdmin,
  banners,
  bannerCreate,
  bannerUpdate,
  bannerUpdateImage,
  banner,
}
